<ion-item>
    <ion-label position="stacked">{{label}}</ion-label>
    <ion-input [formControlName]="controlName"
               [ngClass]="{'error':isError}"
               [placeholder]="placeholder"
               [type]="type"></ion-input>
</ion-item>
